import { LockOutlined } from '@ant-design/icons';
import { Button, Card, Modal, Select, Spin } from 'antd';
import React, { useState } from 'react';

import { apiClient } from '../../graphql/api/apiClient';
import {
  EmergencyScenarioStatus,
  usegetEmergencyScenariosQuery,
} from '../../graphql/api/generated';
import { PermissionScope_enum } from '../../graphql/hasura/generated';
import { useDebouncedSearch } from '../../hooks/useDebouncedSearch';
import { updateEmergencyScenarioStatus } from '../../models/EmergencyScenario/actions';
import { authentication } from '../../stores';
import { Color, displayErrorMessage } from '../../utils';

export const ActivateEmergencyScenario: React.FC<any> = () => {
  const [emergencyScenarioId, setEmergencyScenarioId] = useState<string | undefined>();
  const [touched, setTouched] = useState<boolean>(false);
  const { searchWords, onSearch } = useDebouncedSearch();

  const { permissionScope } = authentication.currentDataScope;

  const { data, loading } = usegetEmergencyScenariosQuery({
    client: apiClient,
    skip: !touched,
    variables: {
      input: {
        filters: {
          status: [EmergencyScenarioStatus.INACTIVE],
          searchTerms: searchWords,
        },
      },
    },
    fetchPolicy: 'cache-and-network',
    onCompleted: (onCompletedData) => {
      const { list } = onCompletedData.emergencyScenarios;

      if (permissionScope !== PermissionScope_enum.GLOBAL && list.length === 1) {
        // Auto-select single result
        setEmergencyScenarioId(list[0].emergencyScenarioId);
      }
    },
  });

  const emergencyScenarios = data?.emergencyScenarios || {
    list: [],
  };

  const emergencyScenarioOptions = emergencyScenarios.list.map(e => ({
    value: e.emergencyScenarioId,
    label: permissionScope === PermissionScope_enum.PROPERTY
      ? e.name
      : `${e.property.name} - ${e.name}`,
  }));

  return (
    <Card
      title={
        <>
          <LockOutlined
            style={{
              backgroundColor: '#fff2f0',
              borderRadius: '50%',
              color: Color.Red,
              marginRight: 10,
              padding: 10,
            }}
          />
          Activate Emergency Scenario
        </>
      }
      bordered={false}
      style={{ marginBottom: 20 }}
    >
      <Select
        showSearch
        value={emergencyScenarioId}
        placeholder={loading ?  'Loading...' : 'Search for emergency scenario'}
        loading={loading}
        notFoundContent={loading ? <Spin /> : null}
        onFocus={() => setTouched(true)}
        onChange={(nextValue) => {
          setEmergencyScenarioId(nextValue);
          onSearch('');
        }}
        allowClear
        filterOption={false}
        onSearch={onSearch}
        virtual={false}
        options={emergencyScenarioOptions}
        style={{ width: '50%', marginRight: 25 }}
      />
      <Button
        htmlType='submit'
        type='primary'
        size='large'
        danger
        disabled={!emergencyScenarioId}
        onClick={() => {
          if (!emergencyScenarioId) {
            return;
          }

          Modal.confirm({
            okType: 'danger',
            centered: true,
            title: 'Activate Emergency Scenario',
            content: 'Are you sure you want to activate this Emergency Scenario?',
            async onOk() {
              try {
                await updateEmergencyScenarioStatus(
                  emergencyScenarioId,
                  EmergencyScenarioStatus.ACTIVE,
                );
              } catch (error) {
                displayErrorMessage(error);
              }
            },
          });
        }}
      >
        Activate
      </Button>
    </Card>
  );
}
